import { useState } from "react";
import { X } from "lucide-react";

export function TagInput({
  value,
  onChange,
  suggestions = [],
  placeholder = "Add a tag…",
}: {
  value: string[];
  onChange: (tags: string[]) => void;
  suggestions?: string[];
  placeholder?: string;
}) {
  const [draft, setDraft] = useState("");

  const add = (raw: string) => {
    const tag = raw.trim().toLowerCase();
    if (!tag || value.includes(tag)) return;
    onChange([...value, tag]);
    setDraft("");
  };
  const remove = (tag: string) => onChange(value.filter((t) => t !== tag));

  const matches = draft.trim()
    ? suggestions
        .filter((s) => s.includes(draft.trim().toLowerCase()) && !value.includes(s))
        .slice(0, 6)
    : [];

  return (
    <div className="space-y-1">
      <div className="flex flex-wrap items-center gap-1 rounded border px-1.5 py-1">
        {value.map((tag) => (
          <span key={tag} className="inline-flex items-center gap-1 rounded bg-muted px-1.5 py-0.5 text-xs">
            {tag}
            <button type="button" aria-label={`Remove ${tag}`} onClick={() => remove(tag)}>
              <X className="h-3 w-3" />
            </button>
          </span>
        ))}
        <input
          type="text"
          value={draft}
          placeholder={placeholder}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === ",") {
              e.preventDefault();
              add(draft);
            } else if (e.key === "Backspace" && !draft && value.length) {
              remove(value[value.length - 1]);
            }
          }}
          className="min-w-[6rem] flex-1 bg-transparent px-1 text-xs outline-none"
        />
      </div>
      {matches.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {matches.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => add(s)}
              className="rounded bg-muted px-1.5 py-0.5 text-xs text-muted-foreground hover:bg-muted/80"
            >
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
